import React, { Component } from 'react'
import { Grid, Row, Col, Table, ButtonGroup, Button } from 'react-bootstrap'
import { object, func } from 'prop-types'
import axios from 'axios'
import { connect } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import moment from 'moment'

import { updateVideo } from '../actions'

import config from '../config'
import { getAuthToken } from '../utils/sessionStorage'

class CampaignSendingManager extends Component {
  constructor (props) {
    super(props)

    this.updateSending = this.updateSending.bind(this)
    this.sendingStatus = this.sendingStatus.bind(this)
  }
  updateSending (status, id) {
    console.log('Preparando para aprovar: ', id)
    const { video, updateVideo } = this.props
    let url = `${config.url}/campaigns/${video.campaign_id}/videos/${video.id}/sendings/`
    let data = {
      sending_id: id,
      status: status
    }
    axios({
      method: 'PUT',
      url: url,
      headers: { 'X-User-Token': getAuthToken() },
      data: data
    })
      .then(res => {
        let updatedVideo = res.data
        updateVideo(video.campaign_id, updatedVideo)
        toastr.success('Sending atualizado com sucesso!')
      })
      .catch(err => {
        toastr.error('Ocorreu um erro. Tente novamente!')
      })
  }
  sendingStatus (status) {
    switch (status) {
      case 'created':
        return <span className='text-info'>Em análise</span>
      case ('approved' || 'executing'):
        return <span className='text-warning'>Produzindo Urls</span>
      case 'rejected':
        return <span className='text-danger'>Rejeitado</span>
      case 'done':
        return <span className='text-success'>Concluído</span>
      default:
        break
    }
  }
  render () {
    const { video } = this.props
    return (
      <Grid>
        <Row>
          <Col md={8}>
            <Table bordered striped>
              <thead>
                <tr>
                  <td>Data de criação</td>
                  <td>Status</td>
                  <th />
                  <th />
                </tr>
              </thead>
              <tbody>
                {video.sendings && video.sendings.map((sending, index) => (
                  <tr key={index}>
                    <td style={{ verticalAlign: 'middle' }}>{moment(sending.created_at).format('LLL')}</td>
                    <td style={{ verticalAlign: 'middle' }}>{this.sendingStatus(sending.status)}</td>
                    <td><a className='btn btn-link' href={sending.data_path} download>Download</a></td>
                    <td style={{ verticalAlign: 'middle' }}>
                      <ButtonGroup>
                        <Button
                          active={sending.status === 'approved'}
                          disabled={sending.status === 'approved'}
                          bsStyle='success'
                          onClick={() => { this.updateSending('approved', sending.id) }}
                        >
                          Aprovar
                        </Button>
                        <Button
                          active={sending.status === 'rejected'}
                          disabled={sending.status === 'rejected'}
                          bsStyle='danger'
                          onClick={() => { this.updateSending('rejected', sending.id) }}
                        >
                          Rejeitar
                        </Button>
                      </ButtonGroup>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Grid>
    )
  }
}

CampaignSendingManager.propTypes = {
  video: object,
  updateVideo: func
}

const mapDispatchToProps = dispatch => ({
  updateVideo: (campaignId, video) => {
    dispatch(updateVideo(campaignId, video))
  }
})

export default connect(null, mapDispatchToProps)(CampaignSendingManager)



// WEBPACK FOOTER //
// ./src/components/CampaignSendingManager.js